module.exports = __webpack_public_path__ + "img/modelarts1.e8895126.png";